import { render, staticRenderFns } from "./YwIntelligentPatrolRecordList.vue?vue&type=template&id=b5b2461a&scoped=true&"
import script from "./YwIntelligentPatrolRecordList.vue?vue&type=script&lang=js&"
export * from "./YwIntelligentPatrolRecordList.vue?vue&type=script&lang=js&"
import style0 from "./YwIntelligentPatrolRecordList.vue?vue&type=style&index=0&id=b5b2461a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b2461a",
  null
  
)

export default component.exports